import Vue from 'vue';
import { ModalService } from '@app/plugins/iview-modal-modify/service';
import i18n from '@app/plugins/i18n';
import { CampaignsService } from '@autocaller_v2/services/CampaignsService';
import ItemForm from '@autocaller_v2/components/campaigns-add-operators.vue';
import MediaUpload from '@autocaller_v2/components/add_welcome_message';

class CampaignsModalService extends ModalService {
  constructor() {
    super(CampaignsService);
  }
  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('autocaller_v2.campaign.modal.remove.content', {
        name: `<strong>${item.name}</strong>`
      })
    });
  }

  add_operators(campaign_id) {
    return this.$open({
      title: i18n.t('autocaller_v2.campaign.field.operators'),
      width: this.size.confirm,

      render: (h) =>
        h(ItemForm, {
          props: {
            campaign_id
          },
          on: {
            success: (data) => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }

  change_status(state, id) {
    const state_key = state ? 'enable' : 'disable';
    const content = i18n.t(`autocaller_v2.campaign.modal.change_status.${state_key}`);
    return this.$confirm({
      loading: true,
      title: i18n.t('shared.component.modal.confirm'),
      content,
      onOk: () => {
        CampaignsService.editItem(id, { active: state })
          .then(() => {
            this.$emit('success');
            this.modal.remove();
          })
          .catch((e) => {
            this.$emit('fail');
            this.modal.setLoading(false);
            Vue.noty.server_error(e);
          })
          .finally(() => {
            this.$emit('finally');
          });
      },
      onCancel: () => this.$emit('finally')
    });
  }

  notice_pbx_module_required() {
    return this.$confirm({
      title: i18n.t('shared.component.modal.warning'),
      content: i18n.t(`autocaller_v2.campaign.modal.notice_pbx_module_required.content`),
      okText: i18n.t(`autocaller_v2.campaign.modal.notice_pbx_module_required.ok`),
      onOk: () => this.$emit('success'),
      onCancel: () => this.$emit('finally')
    });
  }

  open_upload(instance_id, welcome_message_file_id) {
    return this.$open({
      title: i18n.t('autocaller_v2.campaign.welcome_message.modal_title'),
      width: this.size.default,
      closable: false,
      render: (h) =>
        h(MediaUpload, {
          props: { instance_id, welcome_message_file_id },
          on: {
            success: (welcome_message) => {
              this.$emit('success', welcome_message);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new CampaignsModalService();
export { instance as CampaignsModalService };
